import React from 'react';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';

const PersonalInfoStep = ({ formData, errors, onChange }) => {
  const titleOptions = [
    { value: 'mr', label: 'Mr.' },
    { value: 'mrs', label: 'Mrs.' },
    { value: 'miss', label: 'Miss' },
    { value: 'dr', label: 'Dr.' },
    { value: 'prof', label: 'Prof.' }
  ];

  const genderOptions = [
    { value: 'male', label: 'Male' },
    { value: 'female', label: 'Female' }
  ];

  const maritalStatusOptions = [
    { value: 'single', label: 'Single' },
    { value: 'married', label: 'Married' },
    { value: 'divorced', label: 'Divorced' },
    { value: 'widowed', label: 'Widowed' }
  ];

  return (
    <div className="space-y-6">
      <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
        <div className="flex items-start gap-3">
          <div className="w-10 h-10 bg-blue-500 rounded-full flex items-center justify-center flex-shrink-0">
            <span className="text-white text-lg">👤</span>
          </div>
          <div>
            <h3 className="text-lg font-semibold text-gray-900 mb-1">Personal Information</h3>
            <p className="text-sm text-gray-600">
              Please provide your basic personal details. All fields marked with * are required.
            </p>
          </div>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <Select
          label="Title"
          options={titleOptions}
          value={formData?.title}
          onChange={(value) => onChange('title', value)}
          error={errors?.title}
          required
          placeholder="Select title"
        />

        <Input
          label="First Name"
          type="text"
          value={formData?.firstName}
          onChange={(e) => onChange('firstName', e?.target?.value)}
          error={errors?.firstName}
          required
          placeholder="Enter your first name"
        />

        <Input
          label="Middle Name"
          type="text"
          value={formData?.middleName}
          onChange={(e) => onChange('middleName', e?.target?.value)}
          placeholder="Enter your middle name (optional)"
        />

        <Input
          label="Last Name"
          type="text"
          value={formData?.lastName}
          onChange={(e) => onChange('lastName', e?.target?.value)}
          error={errors?.lastName}
          required
          placeholder="Enter your last name"
        />

        <Input
          label="Date of Birth"
          type="date"
          value={formData?.dateOfBirth}
          onChange={(e) => onChange('dateOfBirth', e?.target?.value)}
          error={errors?.dateOfBirth}
          required
          description="Format: DD/MM/YYYY"
        />

        <Select
          label="Gender"
          options={genderOptions}
          value={formData?.gender}
          onChange={(value) => onChange('gender', value)}
          error={errors?.gender}
          required
          placeholder="Select gender"
        />

        <Select
          label="Marital Status"
          options={maritalStatusOptions}
          value={formData?.maritalStatus}
          onChange={(value) => onChange('maritalStatus', value)}
          error={errors?.maritalStatus}
          required
          placeholder="Select marital status"
        />

        <Input
          label="Nationality"
          type="text"
          value={formData?.nationality}
          onChange={(e) => onChange('nationality', e?.target?.value)}
          error={errors?.nationality}
          required
          placeholder="e.g., Nigerian"
        />
      </div>

      <div className="mt-6 space-y-6">
        <div className="bg-green-50 border border-green-200 rounded-lg p-4">
          <div className="flex items-start gap-3">
            <div className="w-10 h-10 bg-green-500 rounded-full flex items-center justify-center flex-shrink-0">
              <span className="text-white text-lg">💼</span>
            </div>
            <div>
              <h3 className="text-lg font-semibold text-gray-900 mb-1">Professional Information</h3>
              <p className="text-sm text-gray-600">
                Tell us about your skills and how you plan to contribute to the organization.
              </p>
            </div>
          </div>
        </div>

        <div className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Skills Set <span className="text-red-500">*</span>
            </label>
            <textarea
              value={formData?.skillsSet}
              onChange={(e) => onChange('skillsSet', e?.target?.value)}
              placeholder="List your key skills, competencies, and areas of expertise (e.g., Communication, Leadership, Technical Skills, etc.)"
              rows={4}
              className={`w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all ${
                errors?.skillsSet ? 'border-red-300 bg-red-50' : 'border-gray-300'
              }`}
            />
            {errors?.skillsSet && (
              <p className="text-sm text-red-600 mt-1">{errors?.skillsSet}</p>
            )}
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              What I Will Be Contributing to the Organization <span className="text-red-500">*</span>
            </label>
            <textarea
              value={formData?.contributionToOrganization}
              onChange={(e) => onChange('contributionToOrganization', e?.target?.value)}
              placeholder="Describe how your skills and experience will benefit the organization during your service year"
              rows={4}
              className={`w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all ${
                errors?.contributionToOrganization ? 'border-red-300 bg-red-50' : 'border-gray-300'
              }`}
            />
            {errors?.contributionToOrganization && (
              <p className="text-sm text-red-600 mt-1">{errors?.contributionToOrganization}</p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PersonalInfoStep;